export const projects = [
  {
    "id": 12,
    "image": "/assets/images/saint-amand-01-apres.jpg",
    "title": "Rénovation d’un appartement — Saint-Amand",
    "title_en": "Apartment Renovation — Saint-Amand",
    "title_zh": "Saint-Amand 公寓改造",
    "location": "Paris",
    "year": "2026",
    "type": "Rénovation",
    "description": "Situé au 14e étage d’un immeuble résidentiel rue Saint-Amand à Paris, cet appartement de plus de 40 m² bénéficie d’un balcon d’environ 10 m² et d’une vue panoramique sur la capitale. Livré en juin 2026, le projet de rénovation vise à révéler les qualités du lieu et à valoriser le bien par une organisation plus lisible, fonctionnelle et généreuse.\n\nLe logement est repensé en deux-pièces, avec un séjour et une chambre indépendante. Une cuisine américaine s’ouvre sur la pièce de vie et accompagne les vues vers Paris. Une porte coulissante permet d’accéder directement à la chambre tout en limitant l’emprise des circulations. La salle d’eau et les toilettes sont séparées pour améliorer le confort au quotidien.\n\nLes rangements intégrés sont développés au maximum afin d’exploiter les volumes disponibles et de libérer l’espace habitable. Le projet conjugue ainsi optimisation d’une petite surface, confort d’usage et mise en valeur de la lumière et du paysage.",
    "description_en": "Located on the 14th floor of a residential building on rue Saint-Amand in Paris, this apartment of over 40 m² features a balcony of approximately 10 m² with panoramic views over the city. Completed in June 2026, the renovation enhances the property's qualities and value through a clearer, more functional and spacious layout.\n\nThe apartment is reorganised as a one-bedroom home, with a living room and a separate bedroom. An American-style open kitchen faces the living space and the Paris skyline. A sliding door provides direct access to the bedroom while keeping circulation compact. The shower room and toilet are separated for everyday comfort.\n\nBuilt-in storage is maximised to make full use of the available volume and keep the living areas clear. The design brings together efficient use of a compact footprint, everyday comfort, natural light and expansive views.",
    "description_zh": "项目位于巴黎 Saint-Amand 街一栋住宅楼的第十四层。公寓室内面积为四十多平方米，另有约十平方米的阳台，可俯瞰巴黎城市全景。改造于 2026 年 6 月竣工，旨在通过更合理的空间组织，充分释放住宅潜力，提升业主物业的使用价值与居住品质。\n\n设计将原有空间重新梳理为一室一厅的两室公寓（T2），兼顾开放的公共活动空间与独立卧室。美式开放厨房面向客厅，与窗外的巴黎景观形成连续的生活场景；卧室通过推拉门直接连接客厅，减少开门与通行对有限面积的占用。淋浴间与厕所分设，让日常使用更加便利。\n\n收纳设计贯穿整个改造，利用可用墙面与空间体积，尽可能扩大一体化储物容量，释放居住空间。项目在有限面积中平衡功能、舒适度与空间感，让自然光和开阔景观成为日常生活的一部分。",
    "images": [
      "/assets/images/saint-amand-04-avant.jpg",
      "/assets/images/saint-amand-05-travaux.jpg",
      "/assets/images/saint-amand-01-apres.jpg",
      "/assets/images/saint-amand-02-cuisine.jpg",
      "/assets/images/saint-amand-03-salle-eau.jpg"
    ],
    "galleryFrameDurations": [600, 600, 600, 3000, 3000],
    "status": "published"
  },
  {
    "id": 1,
    "image": "/assets/images/project-1.jpg",
    "title": "Maison résidentielle expérimentale",
    "location": "Tanzanie",
    "year": "2021",
    "type": "Logement",
    "description": "Prototype modulaire inspiré du concept 'No Boundary', abolissant les limites physiques et sociales du logement. Conçu pour favoriser la solidarité et les liens familiaux, le projet utilise matériaux recyclés, énergies renouvelables et une approche durable adaptée aux contextes vulnérables.",
    "images": [
      "/assets/images/project-1.jpg"
    ],
    "status": "Concours",
    "coverFit": "contain"
  },
  {
    "id": 2,
    "image": "/assets/images/salle-concert-4.jpg",
    "title": "Salle de concert",
    "location": "Nice",
    "year": "2019",
    "type": "Culturel",
    "client": "Mairie",
    "surface": "3000 m²",
    "description": "Ce projet de design intérieur imagine une salle de concert résolument contemporaine, pensée comme un lieu culturel vivant, ouvert et évolutif. L'architecture intérieure met en scène une expérience immersive où la musique, l'espace et les usages sociaux dialoguent en permanence. La salle se développe sur trois niveaux, chacun intégrant un espace public dédié aux rencontres, au partage et aux activités informelles.",
    "images": [
      "/assets/images/salle-concert-4.jpg",
      "/assets/images/salle-concert-1.jpg",
      "/assets/images/salle-concert-2.jpg",
      "/assets/images/salle-concert-3.jpg"
    ],
    "status": "Livré"
  },
  {
    "id": 3,
    "image": "/assets/images/extension-mitry-projet2.jpg",
    "title": "Extension Maison Individuelle",
    "location": "Mitry-Mory",
    "year": "2024",
    "type": "Logement",
    "client": "Propriétaire privé",
    "surface": "150 m²",
    "description": "Du point de vue de l'architecte, ce projet n'était pas seulement une extension, mais une adaptation de la maison à l'évolution de la famille. Le projet a consisté à agrandir la maison vers le jardin avec un volume plus ouvert, une façade en bois et de grandes baies vitrées.",
    "images": [
      "/assets/images/extension-mitry-projet2.jpg",
      "/assets/images/extension-mitry-projet1.jpeg",
      "/assets/images/extension-mitry-existant1.jpg",
      "/assets/images/extension-mitry-existant2.jpg"
    ],
    "status": "Livré"
  },
  {
    "id": 4,
    "image": "/assets/images/1renovation-charenton - projet.jpeg",
    "title": "Rénovation des combles",
    "title_en": "Attic Renovation",
    "title_zh": "屋顶阁楼改造",
    "location": "Charenton",
    "year": "2023",
    "type": "Patrimoine",
    "description": "Le dernier étage, initialement un grenier, a été réaménagé avec l'ajout d'une salle de bain pour devenir le bureau privé du propriétaire.",
    "description_en": "The top floor, originally an attic, was renovated with the addition of a bathroom to become the owner's private study.",
    "description_zh": "最后一层原本的阁楼增加了一个卫生间，变成了主人的书房。",
    "images": [
      "/assets/images/1renovation-charenton - projet.jpeg",
      "/assets/images/2renovation-charenton - existant.jpg",
      "/assets/images/3renovation-charenton - projet.png"
    ],
    "status": "published"
  },
  {
    "id": 5,
    "image": "/assets/images/0.jpeg",
    "title": "Reconquérir l'Usine Champagnole",
    "location": "La Courneuve",
    "year": "2023",
    "type": "Urbanisme",
    "description": "Projet de reconversion d'une friche industrielle à La Courneuve.",
    "images": [
      "/assets/images/0.jpeg",
      "/assets/images/1.jpg",
      "/assets/images/2.jpg",
      "/assets/images/4.jpg",
      "/assets/images/5.jpg",
      "/assets/images/2023 Horizontal 3_page-0010 S.jpg"
    ],
    "status": "published"
  },
  {
    "id": 6,
    "image": "/assets/images/gare-juvissy-0.jpeg",
    "title": "Gare Juvisy-sur-Orge",
    "location": "Juvisy-sur-Orge",
    "year": "2018",
    "type": "Concours",
    "description": "Le site de Juvisy présente une organisation urbaine fragmentée, structurée en lanières parallèles à la Seine. Le projet s'inscrit dans une réflexion sur le franchissement de ces discontinuités urbaines et la requalification des espaces de mobilité. Il vise à améliorer les connexions entre les différents modes de transport tout en favorisant des parcours piétons lisibles et continus.",
    "images": [
      "/assets/images/gare-juvissy-0.jpeg",
      "/assets/images/gare-juvissy-1.jpg",
      "/assets/images/gare-juvissy-2.jpg",
      "/assets/images/gare-juvissy-3.jpg",
      "/assets/images/gare-juvissy-4.jpg"
    ],
    "status": "published",
    "coverFit": "contain"
  },
  {
    "id": 7,
    "image": "/assets/images/momopark-0.jpeg",
    "title": "XIAN centre commercial",
    "location": "Xi'an, Chine",
    "year": "2025",
    "type": "Commerce",
    "description": "Projet commercial Momopark.",
    "images": [
      "/assets/images/momopark-0.jpeg",
      "/assets/images/momopark-1.jpg",
      "/assets/images/momopark-2.jpg",
      "/assets/images/momopark-3.png",
      "/assets/images/momopark-4.jpg"
    ],
    "status": "published"
  },
  {
    "id": 8,
    "image": "/assets/images/logement-bobigny-finale.jpg",
    "title": "Concours de logements collectifs",
    "title_en": "Collective Housing Competition",
    "title_zh": "集合住宅竞赛",
    "location": "Paris",
    "year": "2025",
    "type": "Concours",
    "description": "Projet de concours pour des logements collectifs.",
    "description_en": "Competition project for collective housing.",
    "description_zh": "集合住宅竞赛项目。",
    "images": [
      "/assets/images/logement-bobigny-finale.jpg",
      "/assets/images/logement-bobigny-elevation.png",
      "/assets/images/logement-bobigny-elevation2.png",
      "/assets/images/logement-bobigny-plan-de-masse.png",
      "/assets/images/logement-bobigny-plan-rdc.png",
      "/assets/images/logement-bobigny-plan.png"
    ],
    "status": "published",
    "featured": true
  },
  {
    "id": 9,
    "image": "/assets/images/paris-immobilier.png",
    "title": "Paris Immobilier",
    "location": "Paris",
    "year": "2025",
    "type": "Immobilier",
    "description": "Projet immobilier à Paris.",
    "images": [
      "/assets/images/paris-immobilier.png"
    ],
    "status": "published",
    "featured": true
  },
  {
    "id": 10,
    "image": "/assets/images/Generated Image February 05, 2026 - 10_49PM (1).jpeg",
    "title": "Theatre canal ourque",
    "location": "Paris",
    "year": "2025",
    "type": "Culture",
    "description": "Projet de concours de logement.",
    "images": [
      "/assets/images/Generated Image February 05, 2026 - 10_49PM (1).jpeg",
      "/assets/images/Generated Image February 05, 2026 - 10_51PM.jpeg",
      "/assets/images/projet 0.jpg",
      "/assets/images/projet 2.png",
      "/assets/images/projet 3.png",
      "/assets/images/projet 4.png",
      "/assets/images/projet 5.png",
      "/assets/images/projet1.png"
    ],
    "status": "published",
    "featured": true
  },
  {
    "id": 11,
    "image": "/assets/images/al-city-tower-cover.jpeg",
    "title": "Al City Tower - Cooling Tower",
    "location": "Nouvelle Capitale, Égypte",
    "year": "2022",
    "type": "Commerce",
    "description": "Ce projet est situé dans un quartier commercial moderne de la nouvelle capitale administrative de l'Égypte. Il s'agit d'un programme annexe lié à une tour de refroidissement existante, nécessitant une réflexion architecturale spécifique sur son enveloppe et son intégration urbaine.\n\nLa proposition consiste à concevoir une façade enveloppante qui dissimule et requalifie la fonction technique de la tour de refroidissement. Le projet s'appuie sur une recherche autour des symboles et motifs issus de la culture locale égyptienne, traduits de manière contemporaine à travers le traitement de la peau architecturale. Cette enveloppe agit à la fois comme filtre climatique, élément identitaire et dispositif de mise à distance visuelle de l'infrastructure technique.\n\nAu rez-de-chaussée, le projet introduit un espace public ouvert sous la forme d'une bibliothèque accessible à tous. Cet espace vise à transformer un équipement purement technique en un lieu de partage et de connaissance, offrant de nouvelles possibilités d'usage pour la ville et ses habitants.\n\nLe projet cherche ainsi à dépasser la simple réponse fonctionnelle pour proposer une architecture hybride, où infrastructure, culture et espace public dialoguent afin de renforcer la qualité urbaine du quartier.",
    "images": [
      "/assets/images/al-city-tower-cover.jpeg",
      "/assets/images/220829 WA_页面_08.png",
      "/assets/images/未标题提取页面 .png",
      "/assets/images/未标题提取页面 2.png",
      "/assets/images/Generated Image February 05, 2026 - 4_17PM.jpeg"
    ],
    "status": "published",
    "featured": true
  }
];
